<!-- Sidebar -->
@if(isSidebarOpen) {
  <!-- Overlay -->
  <div
    class="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"
    (click)="toggleSidebar()"
  ></div>

  <!-- Sidebar -->
  <allas-sidebar (closeSidebar)="onCloseSidebar()"></allas-sidebar>
}

<!-- TopBar -->
<allas-top-bar></allas-top-bar>

<!-- Mobile Header -->
<allas-mobile-header 
  [searchQuery]="searchQuery"
  (searchChange)="onSearchChange($event)"
  (toggleSidebar)="toggleSidebar()"
></allas-mobile-header>

<!-- Tablet Header -->
<!-- <allas-tablet-header 
  [searchQuery]="searchQuery"
  (searchChange)="onSearchChange($event)"
  (toggleSidebar)="toggleSidebar()"
></allas-tablet-header> -->

<!-- Desktop Header -->
<allas-desktop-header 
  [searchQuery]="searchQuery"
  (searchChange)="onSearchChange($event)"
  (toggleSidebar)="toggleSidebar()"
></allas-desktop-header>

<!-- Sticky Header -->
<allas-sticky-header 
  [searchQuery]="searchQuery"
  [isScrolled]="isScrolled"
  (searchChange)="onSearchChange($event)"
  (toggleSidebar)="toggleSidebar()"
></allas-sticky-header>
